// import * as api from '@/api/index'
import * as api from '@/api/index'
import { setItem, getItem, removeAllItem } from '@/utils/storage'
import { TOKEN } from '@/constant'
import router from '@/router'
import { setTimeStamp } from '@/utils/timeStamp'
// import _ from 'lodash'

export default {
  namespaced: true,
  state: () => ({
    token: getItem(TOKEN) || '',
    userInfo: {}
  }),
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    /**
     * 登录请求动作
     */
    login(context, userInfo) {
      return new Promise((resolve, reject) => {
        api.user
          .getTelAcctoken(userInfo)
          .then((data) => {
            context.commit('setToken', data.access_token)
            setItem(TOKEN, data.access_token)
            // 登录后操作
            router.go(0)
            // 保存登录时间
            setTimeStamp()
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * 获取用户信息
     */
    async getUserInfo(context) {
      const { data: res } = await api.user.getUserInfo()
      !res.fullName &&
        (res.fullName =
          res.account.substr(0, 3) + '****' + res.account.substr(7))
      const tmpObj = {
        ...res
      }
      context.commit('setUserInfo', tmpObj)
      return tmpObj
    },
    /**
     * 退出登录
     */
    logout(context) {
      context.commit('setToken', '')
      context.commit('setUserInfo', {})
      removeAllItem()
      // TODO 清理权限相关的配置
      // router.push('/login')
      router.go(0)
    }
  }
}
